import { useI18n as useCoreI18n, i18n } from '@qsrsoft/myq-core';
import domainTranslations, { SUPPORTED_LOCALES } from '@/i18n';

// Merge translations eagerly so i18n.global.t works outside Vue components (e.g. catalog files)
for (const locale of SUPPORTED_LOCALES) {
  i18n.global.mergeLocaleMessage(locale, domainTranslations[locale] || {});
}

export { i18n };

export function useI18n(options = {}) {
  options.messages = options.messages || {};
  for (const locale of SUPPORTED_LOCALES) {
    options.messages[locale] = {
      ...domainTranslations[locale],
      ...(options.messages[locale] || {}),
    };
  }
  return useCoreI18n(options);
}
